module.exports = __webpack_public_path__ + "img/6.a4e65098.png";